"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var StackArea = /** @class */ (function (_super) {
    tslib_1.__extends(StackArea, _super);
    function StackArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StackArea.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'stackArea';
        _super.prototype.createLayers.call(this, layerProps);
    };
    StackArea.getDefaultOptions = layer_1.default.getDefaultOptions;
    return StackArea;
}(plot_1.default));
exports.default = StackArea;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/stack-area/index.js
// module id = 978
// module chunks = 37